const invoiceDetailsConstantsAR = {
  invoiceTitle: 'إيصال الطلب',
  invoiceBreadcrumb: 'إيصال الطلب',
  invoiceSubtitle: 'شكراً لإستخدامك منصة سيما',
  invoiceNumber: 'رقم الإيصال:',
  invoiceDate: 'تاريخ الإيصال:',
  invoiceBillTo: 'إيصال الى',
  invoiceFrom: 'من',
  invoiceFromSayma: 'منصة سيما',
  invoiceTableVideoTitleColumn: 'تفاصيل الفيديو',
  invoiceTablePriceColumn: 'السعر',
  invoiceSubtotal: 'المجموع الفرعي',
  invoiceTaxes: 'الضرائب',
  invoiceTotalAmount: 'المجموع الإجمالي',
  discountAmount: 'قيمة الخصم',
};

export default invoiceDetailsConstantsAR;
